import { render, staticRenderFns } from "./ManualAmortizationTableButton.vue?vue&type=template&id=4f823c47&scoped=true&"
import script from "./ManualAmortizationTableButton.vue?vue&type=script&lang=js&"
export * from "./ManualAmortizationTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f823c47",
  null
  
)

export default component.exports